<script setup lang="ts">
import philGalfond from "~/assets/images/training/pros/Phil Galfond.png";
import JasonKoon from "~/assets/images/training/pros/Jason Koon.png";
import danCates from "~/assets/images/training/pros/Dan Cates.png";
import justinBonomo from "~/assets/images/training/pros/Justin Bonomo.png";
import jeremyAusmus from "~/assets/images/training/pros/Jeremy Ausmus.png";
import brianHastings from "~/assets/images/training/pros/Brian Hastings.png";
import kevinRabichow from "~/assets/images/training/pros/Kevin Rabichow.png";

const pros = [
  {
    series: "PLO",
    name: "Phil Galfond",
    image: philGalfond,
  },
  {
    series: "MTT",
    name: "Jason Koon",
    image: JasonKoon,
  },
  {
    series: "NLH Cash",
    name: "Dan Cates",
    image: danCates,
  },
  {
    series: "MTT",
    name: "Justin Bonomo",
    image: justinBonomo,
  },
  {
    series: "MTT",
    name: "Jeremy Ausmus",
    image: jeremyAusmus,
  },
  {
    series: "Mixed Games",
    name: "Brian Hastings",
    image: brianHastings,
  },
  {
    series: "NLH Cash",
    name: "Kevin Rabichow",
    image: kevinRabichow,
  },
];

const containerRef = ref(null);

const swiper = useSwiper(containerRef, {
  breakpoints: {
    300: { spaceBetween: 10, slidesPerView: 2.5 },
    1024: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
});
</script>

<template>
  <div class="mx-auto text-center">
    <div class="mb-3 text-4xl">Elite Pros</div>
    <div class="text-17 mb-10 px-2 opacity-50">
      From No Limit Hold’em to Pot Limit Omaha, tournaments to mixed games,
      we’ve<br />
      got you covered with the best Pros in the industry.
    </div>
    <div>
      <div class="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
        <div
          v-for="pro in pros"
          :key="pro.name"
          class="flex flex-col items-center rounded-lg border border-surface-border p-4"
        >
          <img :src="pro.image" alt="Logo" />
          <div class="mt-2">{{ pro.name }}</div>
          <div class="mt-1 text-primary-200">{{ pro.series }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
